import styled from "styled-components";

export const Form = styled.form`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 540px;
	background: ${({theme}) => theme.background.form};
	border: 2px solid #cccccc;
	border-radius: 6px;
	padding: 30px 80px 40px;

	@media (max-width: 840px) {
		padding: 20px 20px 40px;
	}
`;

export const FormTitle = styled.div`
	text-align: center;
	font-size: 30px;
	font-weight: 700;
	line-height: 34px;
	color: ${({theme}) => theme.color.tertiary};
	max-width: 300px;
	margin-bottom: 26px;

	@media (max-width: 840px) {
		margin-bottom: 30px;
		font-size: 24px;
		max-width: 240px;
	}
`;

export const FormLink = styled.div`
	font-size: 14px;
	text-align: center;

	a {
		color: ${({theme}) => theme.color.secondary};
		font-weight: 700;
		text-decoration: underline;
	}
`;
